import { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import { AppUserContext } from '../../App';
import { ErrorLoading } from '../../components/loading';
import DriverDetails from './driver-details';
import ViewDrivers from './view-drivers';

const Drivers = () => {

    const { profile } = useContext(AppUserContext);

    if (profile.permission_level !== 1) {
        return <ErrorLoading>You do not have the permission to view/add/edit staff members.</ErrorLoading>
    }


    return (
        <Routes>
            <Route path="/:driverid/*" element={<DriverDetails />} />
            <Route path="/" element={<ViewDrivers />} />
        </Routes>
    )
};

export default Drivers;